import React from "react";
import { motion } from "framer-motion";
import { SERVICES } from "@/lib/site";
import { Clock, Sparkles } from "lucide-react";

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-[#F4F1EB] relative">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.28em] text-[#B35B47]">— Sacred Offerings</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#2C302E] leading-[1.05]">
              Nine pathways<br />back to <span className="italic">yourself</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#5C605A] leading-relaxed">
            Every soul is unique. Each healing is intuitively held — woven with
            techniques refined over thousands of hours of practice, and an
            unwavering reverence for your story.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: "easeOut" }}
              data-testid={`service-card-${s.id}`}
              className="group relative bg-[#FAF9F6] rounded-3xl overflow-hidden border border-[#EAE5D9] hover:border-[#C5A880]/60 transition-all duration-500"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.name}
                  className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                />
              </div>
              <div className="p-7 lg:p-8">
                <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#8A8D86]">
                  <Clock className="h-3.5 w-3.5" />
                  {s.duration}
                  <span className="text-[#C5A880]">·</span>
                  <span className="font-medium text-[#B35B47]">{s.price}</span>
                </div>
                <h3 className="font-serif text-3xl mt-3 text-[#2C302E]">{s.name}</h3>
                <p className="mt-3 text-[#5C605A] leading-relaxed">{s.description}</p>
                <ul className="mt-5 flex flex-wrap gap-2">
                  {s.benefits.map((b) => (
                    <li key={b} className="inline-flex items-center gap-1.5 rounded-full bg-[#EAE5D9]/70 text-[#2C302E] text-xs px-3 py-1.5">
                      <Sparkles className="h-3 w-3 text-[#C5A880]" /> {b}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  data-testid={`service-cta-${s.id}`}
                  className="mt-7 inline-flex items-center gap-2 text-sm text-[#2C302E] border-b border-[#2C302E]/40 pb-0.5 hover:text-[#B35B47] hover:border-[#B35B47] transition-colors"
                >
                  Book this session
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
